import { IConfig } from '@cian/config/shared';

import { EPromoType, IPromoInfo } from '../../../types/newbuildingPromos';
import { getCianMortgagePromoUrl } from '../../../utils/motgageCalculator/getCianMortgagePromoUrl';

export const getMortgagePartnerLink = (promo: IPromoInfo, config: IConfig): string | null => {
  if (promo.bank?.isPartner || promo.promoType === EPromoType.CianMortgage) {
    return getCianMortgagePromoUrl(config);
  }

  return null;
};
